module.exports = __webpack_public_path__ + "static/media/thumbnail.01819a9a.jpg";